/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import IDecisionBoxModel from './decisionBox/Model';
import IEndpointSecurityModel from './eps/Model';
import ILogonModel from './logon/Model';
import ILogoutModel from './logout/Model';
import IMessageBoxModel from './messageBox/Model';
import IOauthAuthzModel from './oauthAuthz/Model';
import ITasAuthModel from './tasAuth/Model';
import ITasDeviceRegistrationModel from './tasDeviceRegistration/Model';
import IWebtopModel from './webtop/Model';
import IOktaMfaModel from './oktaMfa/Model';

type IPageModel =
    | IDecisionBoxModel
    | IEndpointSecurityModel
    | ILogonModel
    | ILogoutModel
    | IMessageBoxModel
    | IOauthAuthzModel
    | ITasAuthModel
    | ITasDeviceRegistrationModel
    | IWebtopModel
    | IOktaMfaModel;

export { default as PAGE } from './PageType';
export { IPageModel, IPageModel as default };
